<template>
  <v-dialog v-model="loading" hide-overlay persistent width="300">
    <v-card color="primary">
      <v-card-text>
        <slot></slot>
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: false
      },
    },
  }
</script>

<style scoped>

</style>